// extracted by mini-css-extract-plugin
export default {"Switch":"Switch_Switch__qfqnm","Slider":"Switch_Slider__AFHK+"};